import React, { Dispatch, SetStateAction } from 'react';

import { IPpdPricesDto } from '@r1-frontend/api-domru/ppd-service/dto/IPpdPricesDto';
import { ICurrentCity } from '@r1-frontend/entities/City/models/ICurrentCity';

import { btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { ACTIONS } from '@r1-frontend/shared/constants/analytics';

import Form from '~/src/features/center/Form';
import type { TRefObject } from '~/src/features/center/InfoBlocks';
import SlotButton from '~/src/features/center/SlotButton';
import type { IData } from '~/src/features/center/utils';
import { getWithoutLineTranslation } from '~/src/features/center/utils';

import * as ST from './styled';

export type TDispatch = Dispatch<SetStateAction<boolean>>;

interface IDataInfo {
    data: IData,
    city: ICurrentCity,
    formProblemRefs: TRefObject,
    isHiddenForm: boolean,
    isActiveForm: boolean,
    onClickHandler: (_setState: TDispatch, setActive: TDispatch, actionType: string) => void,
    setActiveForm: TDispatch,
    setActivePriceBlock: TDispatch,
    setHideStatusForm: TDispatch,
    setHideStatusPriceBlock: TDispatch,
    dataPricesFiltered: IPpdPricesDto[],
}

const BlockInfo: React.FC<IDataInfo> = ({
    data,
    city,
    formProblemRefs,
    isHiddenForm,
    isActiveForm,
    onClickHandler,
    setActiveForm,
    setActivePriceBlock,
    setHideStatusPriceBlock,
    setHideStatusForm,
    dataPricesFiltered,
}) => {
    const {
        url,
        mUrl,
        title,
        text,
        index,
        textButton,
        legal,
    } = data;

    const textForPriceButton = !dataPricesFiltered || !dataPricesFiltered.length ? 'Подробнее' : 'Узнать стоимость';

    return (<>
            <ST.Img
                url={url}
                mUrl={mUrl}
                data-test={'img'}
            />
            <ST.ContainerElement>
                <ST.TitleWrapper>
                    <ST.Title data-test={'title'}>
                        {title}
                    </ST.Title>
                </ST.TitleWrapper>
                <ST.TextWrapper>
                    <ST.Text data-test={'text'}>
                        {text}
                    </ST.Text>
                </ST.TextWrapper>
                <ST.ContainerButtons>
                    {isActiveForm && !isHiddenForm
                    ? <Form
                        city={city}
                        withInputName={true}
                        withLegalText={false}
                        textButton={'Перезвонить мне'}
                        setActiveForm={setActiveForm}
                        formProblemRef={formProblemRefs.current[index]}
                        label={`popup | ${getWithoutLineTranslation(title)}`}
                        data-test={'form'}
                        />
                    : <>
                        <SlotButton
                            type={btnTypes.WHITE}
                            defaultText={'Решить проблему'}
                            onClickHandler={onClickHandler}
                            setHideStatus={setHideStatusForm}
                            setActive={setActiveForm}
                            actionType={ACTIONS.clickProblem}
                            data-test={'slot-button-1'}
                        />
                        <SlotButton
                            defaultText={textForPriceButton}
                            textButton={textButton}
                            type={btnTypes.GHOST}
                            onClickHandler={onClickHandler}
                            setHideStatus={setHideStatusPriceBlock}
                            setActive={setActivePriceBlock}
                            actionType={ACTIONS.clickFindPrice}
                            data-test={'slot-button-2'}
                        />
                    </>}
                    {legal && <ST.Legal isActiveForm={isActiveForm} data-test={'legal'}>
                        {legal}
                    </ST.Legal>}
                </ST.ContainerButtons>
            </ST.ContainerElement>
        </>
    );
};

export default BlockInfo;
